import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
//import { EasyFormService } from 'src/app/services/easy-form-service';
import { FnKey, HotKeyService, Priority } from 'src/app/services/hotkey-service';
import { BtnAction, FieldDefine, FormDefine } from './form-define';
import { FontGreatService } from 'src/app/services/font-great.service';
import { EasyNotificationService } from 'src/app/services/easy-notification.service';

@Component({
  selector: 'app-easy-form',
  templateUrl: './easy-form.component.html',
  styleUrls: ['./easy-form.component.css']
})
export class EasyFormComponent implements OnInit,AfterViewInit {

  fg:FormGroup;
  origin:any;
  fnId = 0;
  constructor(@Inject(MAT_DIALOG_DATA) public formDefine: FormDefine,
    private fb:FormBuilder,
    //private fService:EasyFormService,
    private fontGreatService:FontGreatService,
    private notify:EasyNotificationService,
    private keyService:HotKeyService) {
      this.fnId = this.keyService.regist(Priority.Low,'None',(k:string)=>{
        if(k=='Escape'){
          this.close();
        }
      })
  }

  @ViewChild('btn')
  btn: ElementRef<HTMLButtonElement>;

  onClose:(s:number,d:any)=>void;
  ngOnInit(): void {
    this.origin = {}
    this.formDefine.fields.forEach(f=>{
      this.origin[f.name] = f.value;

      if (f.type === 'datetime') {
        // this.origin[`${f.name}_date`] = f.value;
        // this.origin[`${f.name}_time`] = f.value;
        this.origin[`${f.name}_date`] = new Date(f.value);
        this.origin[`${f.name}_time`] = this.extractTime(f.value);
      }
    });

    this.fg = this.fb.group(this.origin);

    this.formDefine.fields.forEach(f=>{
      if (f.type === 'datetime') {
        const time = this.fg.get(f.name + '_time')?.value || '00:00:00';
        const date = this.fg.get(f.name + '_date')?.value || new Date();
        this.updateDateTime(f.name, date, time);
      }

      var validators = [];
      if(f.required){
        validators.push(Validators.required)
      }
      if(f.validator){
        validators.push(...f.validator);
      }
      var control = this.fg.controls[f.name];
      control.setValidators(validators);
      control.markAllAsTouched();
      control.updateValueAndValidity();
    });

    this.fontGreater = this.fontGreatService.getFontGreat();
    setTimeout(() => {

      var el = document.getElementById( 'ez-form-'+this.formDefine.fields[0].name);
      //el.focus();
    }, 1000);
  }
  fontGreater:boolean = false;
  ngAfterViewInit(): void {
    this.btn.nativeElement.focus();
  }

  /** 取消回傳原始值 */
  close(){
    this.keyService.unRegist(this.fnId);
    if(this.formDefine.closeValue){
      var fixed = this.formDefine.closeValue(this.fg.value);
      this.onClose(this.formDefine.formId,fixed)
      //this.fService.formClose(this.formDefine.formId,fixed);
    }else{
      this.onClose(this.formDefine.formId,this.origin)
      //this.fService.formClose(this.formDefine.formId,this.origin);
    }
    this.isWaiting = false;
  }
  isWaiting = false;
  async submit(){
    if(this.fg.valid){
      // 有定義此事件時，進行呼叫，回傳true才可以關閉
      if (this.formDefine.beforeSubmit) {
        //防連點
        this.isWaiting = true;
        try{
          var canSubmit = await this.formDefine.beforeSubmit(this.fg.getRawValue());
          this.isWaiting = false;
          if(!canSubmit){
            return;
          }
        }catch(ex){
          console.log(ex);
          this.notify.showError('表單驗證處理失敗');
          this.isWaiting = false;
        }

      }
      var numField = this.formDefine.fields.filter(x=>x.type=='number');
      numField.forEach(x=>this.fg.controls[x.name].patchValue(Number(this.fg.getRawValue()[x.name])));
      this.keyService.unRegist(this.fnId);
      this.onClose(this.formDefine.formId,this.fg.getRawValue());
      //this.fService.formClose(this.formDefine.formId,this.fg.value);
    }
  }

  async doBtn(btn:{callback:(data)=>BtnAction}){
    setTimeout(async () => {
      if(btn.callback){
        var ret = await btn.callback(this.fg.getRawValue());
        if(ret?.action=='Patch'){
          this.fg.patchValue(ret.data,{emitEvent:false});
        }else if(ret?.action=='close'){
          this.close();
        }
      }
    }, 0);
  }
  async doCustomBtn(btnAct:(data)=>PromiseLike<void>){
    setTimeout(async () => {
      if(btnAct){
        var v = this.fg.getRawValue();
        await btnAct(v);
        this.fg.patchValue(v,{emitEvent:false});
      }
    }, 0);
  }
  // 當選擇日期時
  onDateChange(fieldName: string, event: Date) {
    const time = this.fg.get(fieldName + '_time')?.value || '00:00:00';
    this.updateDateTime(fieldName, event, time);
  }
  // 當選擇時間時
  onTimeChange(fieldName: string, event: string) {
    const date = this.fg.get(fieldName + '_date')?.value || new Date();
    this.updateDateTime(fieldName, date, event);
  }
  extractTime(date: Date | null): string {
    if (!date) return '00:00:00';
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  }
  // 合併日期與時間
  updateDateTime(fieldName: string, date: Date, time: string) {
    if (!date || !time) return;

    let [hours, minutes, seconds] = time.split(':').map(Number);
    let newDateTime = new Date(date);
    newDateTime.setHours(hours, minutes, seconds, 0);

    this.fg.get(fieldName)?.setValue(newDateTime); // 更新原本的 datetime 欄位
  }

  @Input() classList?:string = '';

  onChange(field:FieldDefine){
    if(field.onChange){
      var value = Object.assign({},this.fg.getRawValue())
      field.onChange(value).then(()=>{
        this.fg.patchValue(value)
      });
    }
  }
}
